import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Redirect } from 'react-router';
import { fetchSchoolCreate, REQUEST_SCHOOL_CREATE } from '@/modules/User';
import Centrify from 'sama_global/components/Centrify';
import { Box } from 'UIKit/Grid';
import Panel from 'sama_global/components/Panel';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import Form from 'sama_global/components/Form';
import {
  required,
  email as e,
  minLength4,
  universalPhoneNumber,
} from '@/utils/Validate';

const fields = [
  {
    name: 'email',
    locale: 'EMAIL',
    validate: [required, e],
  },
  {
    name: 'password',
    locale: 'PASSWORD',
    validate: [required, minLength4],
  },
  {
    name: 'name_en',
    locale: 'NAME',
    validate: [required],
  },
  {
    name: 'surname_en',
    locale: 'SURNAME',
    validate: [required],
  },
  {
    name: 'phone',
    locale: 'PHONE',
    validate: [required, universalPhoneNumber],
  },
  {
    name: 'school[name]',
    locale: 'COUNTRY',
    validate: [required],
  },
];

const Create = ({ onCreate, requests, olimpic }) => {
  const request = requests[REQUEST_SCHOOL_CREATE];

  const handleSubmit = formData => {
    onCreate(formData);
  };

  useSnackbarListener(request?.errorMessage);

  return (
    <Centrify>
      <Box py={5} w={1} style={{ maxWidth: '620px', margin: 'auto' }}>
        {request?.success && <Redirect to="/delegates" />}
        <Panel>
          <Form
            title="CREATE_DELEGATE"
            initialValues={{
              meta: { smgl: true, olimpic: olimpic._id },
              lang: 'en',
            }}
            fields={fields}
            onSubmit={handleSubmit}
            fit
            form="delegates_create"
          />
        </Panel>
      </Box>
    </Centrify>
  );
};

Create.propTypes = {
  requests: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  onCreate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  olimpic: state.olimpic.sama,
});

const mapDispatchToProps = dispatch => ({
  onCreate(formData) {
    return dispatch(fetchSchoolCreate(formData));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Create);
